import React from 'react';
import _ from 'lodash';
import t from '../../../i18n/I18n';
import './PublicUrlConfig.css';
import Button from '../../../common/Button';
const debug = require('debug')('wc:assets:PublicUrlConfig');
export default class PublicUrlConfig extends React.Component {
  state = { urls: [''] };

  componentDidMount() {
    const urls: Array<string> = this.props.urls || [];
    this.setState({ urls });
  }
  onChange = (value, index) => {
    const urls: Array<string> = this.state.urls;
    urls[index] = value;
    this.setState({ urls });
    this.props.onChange({ urls: urls });
  };
  onBlur = () => {
    //const urls: Array<string> = this.state.urls;
    //this.props.onChange({ urls: urls });
  };
  addItem = () => {
    const urls: Array<string> = this.state.urls;
    urls.push('');
    this.setState({ urls });
  };
  removeItem = (index) => {
    const urls: Array<string> = this.state.urls;
    urls.splice(index, 1);
    this.setState({ urls });
  };
  renderInputField = (item, index) => {
    return (
      <div className="col-12" key={'url' + index}>
        {/* <div className="col-12"> */}
        <div style={{ width: '100%', display: 'flex' }}>
          <div className="form-group from-group-input">
            <input
              type="text"
              placeholder="Enter URL..."
              value={item}
              onChange={(e) => this.onChange(e.target.value, index)}
              className="form-control"
              onBlur={this.onBlur}
            />
          </div>
          {index === 0 ? null : (
            <div className="delete-button">
              <center>
                <Button icon="images/delete_asset.svg" onClick={() => this.removeItem(index)} />
              </center>
            </div>
          )}
        </div>
        {/* </div> */}
      </div>
    );
  };

  render() {
    const urls: Array<string> = this.state.urls;
    return (
      <div className="row" name="PublicUrlConfig">
        <div className="col-12">
          <div className="row">
            <div className="col-12">
              <label>{t('PUBLIC_URL_INPUT_TITLE')}</label>
            </div>
            {urls.map(this.renderInputField)}
            <div className="col-12">
              <Button icon="images/add_asset_red.svg" className="add-button-style" onClick={this.addItem} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
